"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultThemeManager = void 0;
const tsyringe_1 = require("tsyringe");
const globalSymbols_1 = require("../../../globalSymbols");
const defaults_1 = require("../../../defaults");
let DefaultThemeManager = class DefaultThemeManager {
    constructor(configManager, logger) {
        this.configManager = configManager;
        this.logger = logger;
        this.THEME_CONFIG_NAME = "Theme";
    }
    initialize() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!(yield this.configManager.configurationExists(this.THEME_CONFIG_NAME))) {
                this.logger.log("[Theme Manager]: Theme configuration object does not exist.");
                let configObject = {
                    StylesheetRootDir: defaults_1.defaultStyleSheetRootDir,
                    DefaultThemeName: "AquaBlue",
                    Themes: [
                        {
                            Name: "AquaBlue",
                            Stylesheet: defaults_1.defaultStyleSheet
                        }
                    ]
                };
                yield this.configManager.saveConfiguration(this.THEME_CONFIG_NAME, configObject);
            }
            this.logger.log("[Theme Manager]: Loading theme configuration options.");
            this.themeConfig = yield this.configManager.getConfiguration(this.THEME_CONFIG_NAME);
            this.logger.log(`[Theme Manager]: ${this.themeConfig.DefaultThemeName} theme will be used.`);
            this.defaultTheme = this.themeConfig.Themes.find(t => t.Name == this.themeConfig.DefaultThemeName);
        });
    }
    getSelectedStylesheet() {
        let themePath = this.getStylesheetRootDir() + "/" + this.defaultTheme.Stylesheet;
        this.logger.log(`[Theme Manager]: Applying theme at path: ${themePath}`);
        return themePath;
    }
    getStylesheetRootDir() {
        return this.themeConfig.StylesheetRootDir;
    }
};
DefaultThemeManager = __decorate([
    tsyringe_1.injectable(),
    __param(0, tsyringe_1.inject(globalSymbols_1.TConfigManager)), __param(1, tsyringe_1.inject(globalSymbols_1.TLogger)),
    __metadata("design:paramtypes", [Object, Object])
], DefaultThemeManager);
exports.DefaultThemeManager = DefaultThemeManager;
//# sourceMappingURL=DefaultThemeManager.js.map